import { Card } from 'ui/components/primitives';
import { styled, theme } from 'ui/theme';

export const Container = {
  Card: styled(Card)`
    margin-bottom: ${theme.space[3]};
    margin-top: ${theme.space[5]};

    span {
      display: block;
    }
  `,

  OrderInfo: styled('div')`
    display: grid;
    grid-gap: ${theme.space[2]};
  `,
};
